import {
  CLEAR_INTERVIEWERS,
  FETCH_INTERVIEWERS_FAILURE,
  FETCH_INTERVIEWERS_REQUEST,
  FETCH_INTERVIEWERS_SUCCESS,
} from "./actionTypes";

export const fetchInterviewersRequest = () => ({
  type: FETCH_INTERVIEWERS_REQUEST,
});

export const fetchInterviewersSuccess = (
  interviewers: { name: string; email: string }[]
) => ({
  type: FETCH_INTERVIEWERS_SUCCESS,
  payload: { interviewers },
});

export const fetchInterviewersFailure = (error: string) => ({
  type: FETCH_INTERVIEWERS_FAILURE,
  payload: { error },
});

export const clearInterviewers = () => ({
  type: CLEAR_INTERVIEWERS,
});
